import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterLink, RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TransformPipe} from '@q9elements/ui-kit/common';
import {
  NotificationsModule,
  PageLoaderComponent,
  SidenavModule,
  ThemeSwitcherComponent,
  ToolbarModule,
  TrainingsModule
} from '@q9elements/ui-kit/components';

import {WrapperComponent} from './wrapper.component';

@NgModule({
  declarations: [WrapperComponent],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    MatIconModule,
    RouterLink,
    RouterOutlet,
    MatSidenavModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
    SidenavModule,
    PageLoaderComponent,
    ToolbarModule,
    TrainingsModule,
    Q9TransformPipe,
    MatMenuModule,
    NotificationsModule,
    TrainingsModule,
    ThemeSwitcherComponent
  ]
})
export class WrapperModule {}
